
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DeleteAccountPage extends Vue {
  language = 'es';

  translations = {
    es: {
      title: 'Solicitud de Eliminación de Cuenta',
      paragraph1: 'Para solicitar la eliminación de la cuenta, envíe un correo electrónico a',
      paragraph1End: 'desde el correo electrónico asociado.',
      summaryTitle: 'Resumen de lo que se eliminará:',
      summaryPoint2: 'Se borraran de las chacras las notas creadas con su usuario',
      paragraph2: 'Nos pondremos en contacto con usted para efectuar dicha eliminación.',
      backButton: 'Volver al inicio de sesión'
    },
    pt: {
      title: 'Solicitação de Exclusão de Conta',
      paragraph1: 'Para solicitar a exclusão da conta, envie um e-mail para',
      paragraph1End: 'a partir do correo electrónico associado.',
      summaryTitle: 'Resumo do que será excluído:',
      summaryPoint2: 'Serão removidas das chacras as notas criadas com seu usuário',
      paragraph2: 'Entraremos em contato para efetuar essa exclusão.',
      backButton: 'Voltar ao login'
    }
  };

  goToLogin() {
    this.$router.push('/login');
  }
}
